import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import S3FileUpload from "react-s3";
import { useHistory, useParams } from "react-router-dom";
import Loading from "../../components/Common/Loading";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const EditFeature = (props) => {
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [sections, setSections] = useState([
    {
      title: "",
      heading: "",
      description: "",
      image: "",
      box1_title: "",
      box2_title: "",
      box3_title: "",
      box1_description: "",
      box2_description: "",
      box3_description: "",
    },
  ]);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();
  const { id } = useParams();
  const history = useHistory();
  const user = useSelector((state) => state.User);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);
  const allFields = watch();
  // get feature details
  const getFeature = () => {
    setIsLoading(true);
    apiReq(url.DETAILS_FEATURE + id, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setValue("title", res.data.title);
          setValue("heading", res.data.heading);
          setValue("description", res.data.description);
          setValue("cta_title", res.data.cta_title);
          setValue("cta_title", res.data.cta_title);
          setValue("cta_link", res.data.cta_link);
          setValue("index", res.data.index);
          setValue("meta_description", res.data.meta_description);
          setImage(res.data.image);
          setSections(res.data.sections);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getFeature();
  }, [id]);

  const config = {
    bucketName: process.env.REACT_APP_BUCKET_NAME,
    dirName: "features",
    region: "eu-central-1",
    accessKeyId: process.env.REACT_APP_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_ACCESS_SECRET,
  };

  // HandleImageUpload
  const handleLogoUpload = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        setImage(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };

  // handleSectionImage
  const handleSectionImage = (event, index) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        console.log(
          "image upload",
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
        const newSection = [...sections];
        newSection[index][
          "image"
        ] = `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`;
        setSections(newSection);
      })
      .catch((err) => console.log(err));
  };

  // removeSectionImage
  const removeSectionImage = (index) => {
    const newSection = [...sections];
    newSection[index]["image"] = "";
    setSections(newSection);
  };

  // handleSectionChange
  const handleSectionChange = (event, index) => {
    const newSection = [...sections];
    newSection[index][event.target.name] = event.target.value;
    setSections(newSection);
  };

  // addNewSection
  const addNewSection = () => {
    setSections([
      ...sections,
      {
        title: "",
        heading: "",
        description: "",
        image: "",
        box1_title: "",
        box2_title: "",
        box3_title: "",
        box1_description: "",
        box2_description: "",
        box3_description: "",
      },
    ]);
  };

  // deleteSection
  const deleteSection = (index) => {
    const newSection = [...sections];
    newSection.splice(index, 1);
    setSections(newSection);
  };

  //   console.log("sections>>>", sections);

  // Todo: onSubmit
  const onSubmit = (data) => {
    if (image === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Upload Image",
      });
      return;
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_FEATURE + id,
        {
          title: data.title,
          description: data.description,
          heading: data.heading,
          image: image,
          cta_title: data.cta_title,
          cta_link: data.cta_link,
          slug: data.title.toLowerCase().split(" ").join("-"),
          sections: sections,
          index: data.index,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          if (res.success && res.data !== null) {
            history.push("/features");
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  // Todo: Drag and Drop
  const onDragEndHandle = (result) => {
    if (!result.destination) return;
    const items = Array.from(sections);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setSections(items);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Update feature page</h5>
              <hr />
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mt-4">
                  <h5>Intro Section</h5>
                  <hr />
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label>Image</label>
                      <div
                        className="dropzone p-4 mb-3"
                        style={{ minHeight: 120 }}
                      >
                        {!image ? (
                          <div
                            className="needsclick"
                            // {...getRootProps()}
                          >
                            {/* <input /> */}
                            <div className="mb-3">
                              <i className="ri-image-line display-4 text-muted"></i>
                            </div>
                            <h5 className="opacity-40">Featured Image</h5>
                            <small className="text-muted mb-0 text-center">
                              <strong>(580X405)</strong>
                            </small>
                            <input
                              type="file"
                              className="image_upload_input"
                              onChange={(e) => handleLogoUpload(e)}
                            />
                          </div>
                        ) : (
                          <div className="filled_image">
                            <img
                              src={image}
                              alt="image"
                              className="img-fluid"
                            />
                            <div
                              className="remove_image"
                              onClick={() => setImage(null)}
                            >
                              <i className="mdi mdi-close-thick"></i>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="row">
                      <div className="col-md-5">
                        <div className="mb-3">
                          <label>
                            Title{" "}
                            <small
                              className="text-muted"
                              style={{ opacity: 0.5 }}
                            >
                              ({allFields?.title?.length} / 25)
                            </small>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter title"
                            {...register("title", { required: true })}
                          />
                          {errors.title && (
                            <span className="text-danger">
                              Title is required
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-5">
                        <div className="mb-3">
                          <label>
                            Heading{" "}
                            <small
                              className="text-muted"
                              style={{ opacity: 0.5 }}
                            >
                              ({allFields?.heading?.length} / 45)
                            </small>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter heading"
                            {...register("heading", { required: true })}
                          />
                          {errors.heading && (
                            <span className="text-danger">
                              Heading is required
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="mb-3">
                          <label>Index</label>
                          <input
                            type="number"
                            defaultValue={0}
                            className="form-control"
                            placeholder="Enter index"
                            {...register("index", { required: true })}
                          />
                          {errors.index && (
                            <span className="text-danger">
                              Index is required
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label>
                        Description{" "}
                        <small className="text-muted" style={{ opacity: 0.5 }}>
                          ({allFields?.description?.length} / 200)
                        </small>
                      </label>
                      <textarea
                        type="text"
                        className="form-control"
                        placeholder="Enter description"
                        {...register("description", { required: true })}
                        style={{ resize: "none", minHeight: 80 }}
                      />
                      {errors.description && (
                        <span className="text-danger">
                          Description is required
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label>CTA Title</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter title"
                        {...register("cta_title", { required: true })}
                      />
                      {errors.cta_title && (
                        <span className="text-danger">
                          CTA Title is required
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label>CTA Link</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter title"
                        {...register("cta_link", { required: true })}
                      />
                      {errors.cta_link && (
                        <span className="text-danger">
                          CTA Link is required
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <h5>Sections</h5>
                <hr />
                <DragDropContext
                  onDragEnd={(result) => onDragEndHandle(result)}
                >
                  <Droppable droppableId="sectionItems_wrapper">
                    {(provided) => (
                      <div
                        className="sectionItems_wrapper"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {sections.map((item, index) => (
                          <Draggable
                            key={index}
                            draggableId={"dd" + index}
                            index={index}
                          >
                            {(provided) => (
                              <div
                                className="section_wrap_"
                                {...provided.draggableProps}
                                ref={provided.innerRef}
                              >
                                <div className="section_wrap">
                                  <div className="section_header">
                                    <div className="mb-3 row">
                                      <div className="col-md-8">
                                        <h5 className="section_title">
                                          <span
                                            className="move_secction"
                                            {...provided.dragHandleProps}
                                          >
                                            <i className="ri-drag-move-2-line"></i>
                                          </span>{" "}
                                          Section {index + 1}: {item.title}
                                        </h5>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="d-flex justify-content-end">
                                          <button
                                            className="btn btn-danger"
                                            type="button"
                                            onClick={() => deleteSection(index)}
                                          >
                                            <i className="ri-delete-bin-line"></i>{" "}
                                            Delete this section
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row" key={index}>
                                    <div className="col-md-4">
                                      <label>Section Image</label>
                                      <div className="image_wrap">
                                        <div
                                          className="dropzone p-4 mb-3"
                                          style={{ minHeight: 120 }}
                                        >
                                          {!item.image ? (
                                            <div
                                              className="needsclick"
                                              // {...getRootProps()}
                                            >
                                              {/* <input /> */}
                                              <div className="mb-3">
                                                <i className="ri-image-line display-4 text-muted"></i>
                                              </div>
                                              <h5 className="opacity-40">
                                                Section Image
                                              </h5>
                                              <small className="text-muted mb-0 text-center">
                                                <strong>(580X405)</strong>
                                              </small>
                                              <input
                                                type="file"
                                                className="image_upload_input"
                                                onChange={(e) =>
                                                  handleSectionImage(e, index)
                                                }
                                              />
                                            </div>
                                          ) : (
                                            <div className="filled_image">
                                              <img
                                                src={item.image}
                                                alt={item.title}
                                                className="img-fluid"
                                              />
                                              <div
                                                className="remove_image"
                                                onClick={() =>
                                                  removeSectionImage(index)
                                                }
                                              >
                                                <i className="mdi mdi-close-thick"></i>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-8">
                                      <div className="row">
                                        <div className="col-md-6">
                                          <div className="mb-3">
                                            <label>
                                              Title{" "}
                                              <small
                                                className="text-muted"
                                                style={{ opacity: 0.5 }}
                                              >
                                                (30)
                                              </small>
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter title"
                                              name="title"
                                              value={item.title}
                                              onChange={(e) =>
                                                handleSectionChange(e, index)
                                              }
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-6">
                                          <div className="mb-3">
                                            <label>
                                              Heading{" "}
                                              <small
                                                className="text-muted"
                                                style={{ opacity: 0.5 }}
                                              >
                                                (60)
                                              </small>
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Enter heading"
                                              name="heading"
                                              value={item.heading}
                                              onChange={(e) =>
                                                handleSectionChange(e, index)
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="mb-3">
                                        <label>
                                          Description{" "}
                                          <small
                                            className="text-muted"
                                            style={{ opacity: 0.5 }}
                                          >
                                            (160)
                                          </small>
                                        </label>
                                        <textarea
                                          className="form-control"
                                          placeholder="Enter description"
                                          name="description"
                                          value={item.description}
                                          onChange={(e) =>
                                            handleSectionChange(e, index)
                                          }
                                          style={{
                                            resize: "none",
                                            minHeight: 80,
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <h5>Value boxes</h5>
                                  <hr />
                                  <div className="row">
                                    <div className="col-md-4">
                                      <div className="mb-3">
                                        <label>
                                          Box 1 title{" "}
                                          <small
                                            className="text-muted"
                                            style={{ opacity: 0.5 }}
                                          >
                                            (30)
                                          </small>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Enter title"
                                          name="box1_title"
                                          value={item.box1_title}
                                          onChange={(e) =>
                                            handleSectionChange(e, index)
                                          }
                                        />
                                      </div>
                                      <div className="mb-3">
                                        <label>
                                          Box 1 description{" "}
                                          <small
                                            className="text-muted"
                                            style={{ opacity: 0.5 }}
                                          >
                                            (140)
                                          </small>
                                        </label>
                                        <textarea
                                          type="text"
                                          className="form-control"
                                          placeholder="Enter description"
                                          name="box1_description"
                                          value={item.box1_description}
                                          onChange={(e) =>
                                            handleSectionChange(e, index)
                                          }
                                          style={{
                                            resize: "none",
                                            minHeight: 80,
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="mb-3">
                                        <label>
                                          Box 2 title{" "}
                                          <small
                                            className="text-muted"
                                            style={{ opacity: 0.5 }}
                                          >
                                            (30)
                                          </small>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Enter title"
                                          name="box2_title"
                                          value={item.box2_title}
                                          onChange={(e) =>
                                            handleSectionChange(e, index)
                                          }
                                        />
                                      </div>
                                      <div className="mb-3">
                                        <label>
                                          Box 2 description{" "}
                                          <small
                                            className="text-muted"
                                            style={{ opacity: 0.5 }}
                                          >
                                            (140)
                                          </small>
                                        </label>
                                        <textarea
                                          type="text"
                                          className="form-control"
                                          placeholder="Enter description"
                                          name="box2_description"
                                          value={item.box2_description}
                                          onChange={(e) =>
                                            handleSectionChange(e, index)
                                          }
                                          style={{
                                            resize: "none",
                                            minHeight: 80,
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="mb-3">
                                        <label>
                                          Box 3 title{" "}
                                          <small
                                            className="text-muted"
                                            style={{ opacity: 0.5 }}
                                          >
                                            (30)
                                          </small>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Enter title"
                                          name="box3_title"
                                          value={item.box3_title}
                                          onChange={(e) =>
                                            handleSectionChange(e, index)
                                          }
                                        />
                                      </div>
                                      <div className="mb-3">
                                        <label>
                                          Box 3 description{" "}
                                          <small
                                            className="text-muted"
                                            style={{ opacity: 0.5 }}
                                          >
                                            (140)
                                          </small>
                                        </label>
                                        <textarea
                                          type="text"
                                          className="form-control"
                                          placeholder="Enter description"
                                          name="box3_description"
                                          value={item.box3_description}
                                          onChange={(e) =>
                                            handleSectionChange(e, index)
                                          }
                                          style={{
                                            resize: "none",
                                            minHeight: 80,
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>

                <hr />
                <div className="d-flex justify-content-end mt-2">
                  <button
                    className="btn btn-success"
                    type="button"
                    onClick={() => addNewSection()}
                  >
                    Add New Section
                  </button>
                </div>
                <h5 className="mt-4">SEO Meta Tags</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Meta Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_title?.length} / 70)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_title", { required: false })}
                    placeholder="Enter title"
                  />
                </div>
                <div className="mb-3">
                  <label>
                    Meta Description{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_description?.length} / 200)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_description", { required: false })}
                    placeholder="Enter description"
                  />
                </div>
                <hr />

                <div>
                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditFeature;
